module.exports = __webpack_public_path__ + "static/pat_sullivan-fe788f3695d3775e5ea00ea2a2b5d810.jpg";